import React from 'react'
import { Box, Typography } from '@mui/material'
import { Trans } from 'react-i18next'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/** Tabs steps component */
export const EmobilityTabsStep: React.FC = () => {
  const { t } = useCustomTranslation()

  return (
    <Box>
      <Typography>{t('emobility.tour.tabs-title')}</Typography>

      <Box mt={2}>
        <Trans i18nKey="emobility.tour.tabs" components={{ strong: <strong /> }} />
      </Box>

      <Typography mt={2}>{t('emobility.tour.tabs-content')}</Typography>
    </Box>
  )
}
